import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  Link,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Button } from 'primereact/button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { CommonMasterService } from '../../remote-api/api/newgmc-service/newgmc.service';
import { Subscription } from 'rxjs';

const NewGmcComponent = () => {
  const [conditionTable, setConditionTable] = useState(false);
  const [agreementCode, setAgreementCode] = useState('');
  const [showTable, setShowTable] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showValidationMsg, setShowValidationMsg] = useState(false);
  const [rateChartTypes, setRateChartTypes] = useState([]);
  const [policyTypes, setPolicyTypes] = useState([]);
  const [policyIssuanceTypes, setPolicyIssuanceTypes] = useState([]);
  const [tpaTypes, setTpaTypes] = useState([]);
  const [corporateTypes, setCorporateTypes] = useState([]);
  const [cusetomerSegment, setCustomerSegment] = useState([]);
  const [claimBeneficiary, setClaimBeneficiary] = useState([]);
  const [quoteTypes, setQuoteTypes] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [quotationNo, setQuotationNo] = useState('');
  const [formData, setFormData] = useState({
    corporate: '',
    rateChartType: '',
    policyType: '',
    tpaType: '',
    policyIssuanceType: '',
    // previousPolicy: '',
  });

  const commonService = new CommonMasterService();

  console.log(formData?.corporate);
  console.log(formData?.rateChartType);

  const today = new Date();
  const oneYearLater = new Date();
  oneYearLater.setFullYear(today.getFullYear() + 1);

  const formatDate = date => date.toISOString().split('T')[0];

  const [basicForm, setBasicForm] = useState({
    spCode: '',
    customerSegment: '',
    ssmId: '',
    ssmName: '',
    policyFrom: formatDate(today),
    policyUpto: formatDate(oneYearLater),
    quoteNo: '',
    inwardNo: '',
    secureId: '',
    agentCommission: '',
    benefitChartPdf: null,
    benefitChartExcel: null,
    claimBeneficiary: '', // <== new
    quoteType: '', // <== new
    settlementType: '',
  });

  const [rows, setRows] = useState([
    {
      id: 1,
      description: 'Entry Age - Self',
      type: 'Age',
      subType: 'Self',
      min: 18,
      max: 65,
    },
    {
      id: 2,
      description: 'Entry Age - Child',
      type: 'Age',
      subType: 'Child',
      min: 18,
      max: 65,
    },
    {
      id: 3,
      description: 'Entry Age - Spouse',
      type: 'Age',
      subType: 'Spouse',
      min: 0,
      max: 25,
    },
    {
      id: 4,
      description: 'Entry Age - Parent',
      type: 'Age',
      subType: 'Parent',
      min: 18,
      max: 65,
    },
    {
      id: 5,
      description: 'Entry Age - Parent In Law',
      type: 'Age',
      subType: 'Parent-In-Law',
      min: 18,
      max: 65,
    },
    {
      id: 6,
      description: 'Fam Size - Self',
      type: 'Famsize',
      subType: 'Self',
      min: '',
      max: 1,
    },
    {
      id: 7,
      description: 'Fam Size - Spouse',
      type: 'Famsize',
      subType: 'Spouse',
      min: '',
      max: 1,
    },
    {
      id: 8,
      description: 'Fam Size - Child',
      type: 'Famsize',
      subType: 'Child',
      min: '',
      max: 2,
    },
    {
      id: 9,
      description: 'Fam Size - Parent',
      type: 'Famsize',
      subType: 'Parent',
      min: '',
      max: 2,
    },
    {
      id: 10,
      description: 'Fam Size - Parent-In-Law',
      type: 'Famsize',
      subType: 'Parent-In-Law',
      min: '',
      max: 2,
    },
  ]);

  const agreementRows = [
    {
      id: 1,
      SBIGRMID: 'NA',
      intermediaryCode: '0002073',
      intermediaryName: 'RaghuSingh',
      agreementName: 'RaghuSingh-HO',
      agreementCode: '0016577',
      agentEffDate: '13-Feb-08',
      agentExoDate: '17-Feb-29',
      rmName: 'NA',
      sbiChannel: 'Corporate Broker and Direct',
      sbiChannel1: 'AGRI',
      sbiChannel2: 'Arvind Auto Consultant',
      IRDAChannel: 'Bank',
      sbiGeneralBranch: 'HO',
      branchGstNumber: '27AAMCS8857L1ZC',
      sbiGeneralBranchCode: '201904091322755',
      sbiGeneralBranchName: 'SBI Geneal Insurance Name Co Ltd Mumbai',
    },
  ];

  const handleAgreementChange = e => {
    const value = e.target.value;

    // Allow only digits
    if (/^\d*$/.test(value)) {
      setAgreementCode(value);

      // Show table if exactly 6 digits
      setShowTable(value.length === 7);
    }
  };
  const handleInputChange = (index, field) => event => {
    const updatedRows = [...rows];
    updatedRows[index][field] = event.target.value;
    setRows(updatedRows);
  };

  const handleChange = field => event => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleBasicChange = field => event => {
    setBasicForm(prev => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleBasicFileChange = field => event => {
    console.log(field);

    const file = event.target.files[0] || null;
    setBasicForm(prev => ({
      ...prev,
      [field]: file,
    }));
  };

  const isFormValid = () => {
    return (
      formData.corporate && formData.rateChartType && formData.policyType && formData.tpaType && formData.policyIssuanceType
      // formData.previousPolicy
    );
  };

  const handleActive = () => {
    setConditionTable(prev => !prev);
    setFormDisabled(true);
  };

  const generateQuotationNo = () => {
    const code = 'C0001';
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const randomNum = Math.floor(100 + Math.random() * 900); // e.g., 297
    return `${code}\\${year}\\${month}\\QTN-${randomNum}`;
  };

  const handleGenerateQuotation = () => {
    const newQuotation = generateQuotationNo();
    setQuotationNo(newQuotation);
    setOpenDialog(true);
  };

  const handleDownloadTemplate = () => {
    const payload = {
      corporateId: formData?.corporate,
      rateChartTypeId: formData?.rateChartType,
    };

    commonService.downloadTemplate(payload).subscribe({
      next: response => {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'template.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: err => {
        console.error('Download failed:', err);
      },
    });
  };

  useEffect(() => {
    const subscriptionRateChart = commonService.getRateChartType().subscribe({
      next: data => {
        console.log(data);
        if (Array.isArray(data?.content) && data?.content?.length > 0 && data?.content[0]?.children) {
          const transformed = data?.content[0]?.children.map(child => ({
            value: child.id,
            label: child.commonDesc,
          }));
          setRateChartTypes(transformed);
        }
      },
      error: err => {
        console.error('Error fetching rate chart types', err);
      },
    });

    // cleanup subscription on unmount
    return () => subscriptionRateChart.unsubscribe();
  }, []);

  useEffect(() => {
    const subscriptionPolicyType = commonService.getPolicyType().subscribe({
      next: data => {
        console.log(data);
        if (Array.isArray(data?.content) && data?.content?.length > 0 && data?.content[0]?.children) {
          const transformed = data?.content[0]?.children.map(child => ({
            value: child.commonCode,
            label: child.commonDesc,
          }));
          setPolicyTypes(transformed);
        }
      },
      error: err => {
        console.error('Error fetching rate chart types', err);
      },
    });

    // cleanup subscription on unmount
    return () => subscriptionPolicyType.unsubscribe();
  }, []);

  useEffect(() => {
    const subscriptionPolicyIssuanceType = commonService.getPolicyIssuanceType().subscribe({
      next: data => {
        console.log(data);
        if (Array.isArray(data?.content) && data?.content?.length > 0 && data?.content[0]?.children) {
          const transformed = data?.content[0]?.children.map(child => ({
            value: child.commonCode,
            label: child.commonDesc,
          }));
          setPolicyIssuanceTypes(transformed);
        }
      },
      error: err => {
        console.error('Error fetching rate chart types', err);
      },
    });

    // cleanup subscription on unmount
    return () => subscriptionPolicyIssuanceType.unsubscribe();
  }, []);

  useEffect(() => {
    const subscriptionTPAType = commonService.getTPAType().subscribe({
      next: data => {
        console.log(data);
        if (Array.isArray(data?.content) && data?.content?.length > 0 && data?.content) {
          const transformed = data?.content?.map(child => ({
            value: child.orgCode,
            label: child.orgName,
          }));
          setTpaTypes(transformed);
        }
      },
      error: err => {
        console.error('Error fetching rate chart types', err);
      },
    });

    // cleanup subscription on unmount
    return () => subscriptionTPAType.unsubscribe();
  }, []);

  useEffect(() => {
    const subscriptionCorporateype = commonService.getCorporateType().subscribe({
      next: data => {
        console.log(data);
        if (Array.isArray(data?.content) && data?.content?.length > 0 && data?.content) {
          const transformed = data?.content?.map(child => ({
            value: child.id,
            label: child.orgName,
          }));
          setCorporateTypes(transformed);
        }
      },
      error: err => {
        console.error('Error fetching rate chart types', err);
      },
    });

    // cleanup subscription on unmount
    return () => subscriptionCorporateype.unsubscribe();
  }, []);

  useEffect(() => {
    const subscriptionCustomerSegment = commonService.getCustomerSegment().subscribe({
      next: data => {
        // setRateChartTypes(data.content || []); // assuming response has { content: [...] }
        console.log(data);
        if (Array.isArray(data?.content) && data?.content?.length > 0 && data?.content[0]?.children) {
          const transformed = data?.content[0]?.children?.map(child => ({
            value: child.commonCode,
            label: child.commonDesc,
          }));
          setCustomerSegment(transformed);
        }
      },
      error: err => {
        console.error('Error fetching rate chart types', err);
      },
    });

    // cleanup subscription on unmount
    return () => subscriptionCustomerSegment.unsubscribe();
  }, []);

  useEffect(() => {
    const subscriptionClaimBeneficiary = commonService.getClaimBeneficiery().subscribe({
      next: data => {
        // setRateChartTypes(data.content || []); // assuming response has { content: [...] }
        console.log(data);
        if (Array.isArray(data?.content) && data?.content?.length > 0 && data?.content[0]?.children) {
          const transformed = data?.content[0]?.children?.map(child => ({
            value: child.commonCode,
            label: child.commonDesc,
          }));
          setClaimBeneficiary(transformed);
        }
      },
      error: err => {
        console.error('Error fetching rate chart types', err);
      },
    });

    // cleanup subscription on unmount
    return () => subscriptionClaimBeneficiary.unsubscribe();
  }, []);

  useEffect(() => {
    const subscriptionQuoteType = commonService.getQuoteType().subscribe({
      next: data => {
        // setRateChartTypes(data.content || []); // assuming response has { content: [...] }
        console.log(data);
        if (Array.isArray(data?.content) && data?.content?.length > 0 && data?.content[0]?.children) {
          const transformed = data?.content[0]?.children?.map(child => ({
            value: child.commonCode,
            label: child.commonDesc,
          }));
          setQuoteTypes(transformed);
        }
      },
      error: err => {
        console.error('Error fetching rate chart types', err);
      },
    });

    // cleanup subscription on unmount
    return () => subscriptionQuoteType.unsubscribe();
  }, []);

  useEffect(() => {
    setShowValidationMsg(false);
  }, [formData]);

  return (
    <Box>
      {conditionTable === true ? (
        <Grid container spacing={1} alignItems="center">
          <Typography style={{ color: 'red' }}>Premium Chart Rate Uploaded Successfully</Typography>
        </Grid>
      ) : null}

      <Box
        style={{
          margin: '10px 0',
          border: '2px solid blue', // 👈 this adds the border
          borderRadius: '10px',
          padding: '16px', // optional, for better spacing
          // display: 'flex',
          // justifyContent: 'center',
          // flexDirection: 'row',
        }}>
        <Typography>Create New Quotation</Typography>

        <Grid container spacing={2} alignItems="flex-start">
          <Grid
            container
            spacing={4}
            alignItems="center"
            style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between' }}>
            <Grid item xs={3}>
              <Autocomplete
                options={corporateTypes}
                getOptionLabel={option => option.label}
                value={corporateTypes.find(c => c.value === formData.corporate) || null}
                onChange={(e, newValue) => setFormData({ ...formData, corporate: newValue ? newValue.value : '' })}
                filterOptions={(options, { inputValue }) => {
                  if (inputValue.length < 3) return []; // hide until 3 letters
                  return options.filter(option => option?.label?.toLowerCase().includes(inputValue.toLowerCase()));
                }}
                renderInput={params => (
                  <TextField {...params} label="Select Corporate" variant="standard" margin="dense" size="small" />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <Autocomplete
                options={tpaTypes}
                getOptionLabel={option => option.label}
                value={tpaTypes.find(t => t.value === formData.tpaType) || null}
                onChange={(e, newValue) => setFormData({ ...formData, tpaType: newValue ? newValue.value : '' })}
                disableClearable
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Select TPA Type"
                    variant="standard"
                    margin="dense"
                    size="small"
                    inputProps={{
                      ...params.inputProps,
                      readOnly: true, // ✅ disables typing/search
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <Autocomplete
                options={rateChartTypes}
                getOptionLabel={option => option.label}
                value={rateChartTypes.find(t => t.value === formData.rateChartType) || null}
                onChange={(e, newValue) => setFormData({ ...formData, rateChartType: newValue ? newValue.value : '' })}
                disableClearable
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Select rate chart Type"
                    variant="standard"
                    margin="dense"
                    size="small"
                    inputProps={{
                      ...params.inputProps,
                      readOnly: true, // ✅ disables typing/search
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            alignItems="center"
            style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between' }}>
            <Grid item xs={3}>
              <Autocomplete
                options={policyTypes}
                getOptionLabel={option => option.label}
                value={policyTypes.find(t => t.value === formData.policyType) || null}
                onChange={(e, newValue) => setFormData({ ...formData, policyType: newValue ? newValue.value : '' })}
                disableClearable
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Select Policy Type"
                    variant="standard"
                    margin="dense"
                    size="small"
                    inputProps={{
                      ...params.inputProps,
                      readOnly: true, // ✅ disables typing/search
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <Autocomplete
                options={policyIssuanceTypes}
                getOptionLabel={option => option.label}
                value={policyIssuanceTypes.find(t => t.value === formData.policyIssuanceType) || null}
                onChange={(e, newValue) => setFormData({ ...formData, policyIssuanceType: newValue ? newValue.value : '' })}
                disableClearable
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Select Policy Issuance Type"
                    variant="standard"
                    margin="dense"
                    size="small"
                    inputProps={{
                      ...params.inputProps,
                      readOnly: true, // ✅ disables typing/search
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                size="small"
                margin="dense"
                fullWidth
                variant="standard"
                label="Previous Policy"
                disabled={formDisabled}
                // value={formData.previousPolicy}
                // onChange={handleChange('previousPolicy')}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems="center" style={{ marginTop: 20 }}>
          <Grid item>
            {/* <Link
              variant="standard"
              onClick={() => {
                if (isFormValid()) {
                  // window.open('/1753277264713.xlsx', '_blank');
                  handleDownloadTemplate();
                  setShowValidationMsg(false);
                } else {
                  setShowValidationMsg(true);
                }
              }}>
              Download Format
            </Link> */}
            <Typography
              onClick={() => {
                if (isFormValid()) {
                  handleDownloadTemplate();
                  setShowValidationMsg(false);
                } else {
                  setShowValidationMsg(true);
                }
              }}>
              Download Format
            </Typography>
            {showValidationMsg && (
              <Typography color="error" sx={{ mt: 1 }}>
                Please fill all fields to enable download
              </Typography>
            )}
          </Grid>

          <Grid item>
            <FormControl variant="standard" margin="dense" size="small">
              {/* <InputLabel shrink htmlFor="upload-file-input">
                Choose File
              </InputLabel> */}
              <OutlinedInput
                notched
                id="upload-file-input"
                type="file"
                label="Choose File"
                inputProps={{ accept: '.xlsx,.csv' }}
                onChange={e => setSelectedFile(e.target.files[0])}
              />
            </FormControl>
          </Grid>

          {/* Upload Button */}
          <Grid item>
            <Button
              variant="standard"
              color="primary"
              startIcon={<CloudUploadIcon />}
              disabled={!selectedFile}
              onClick={handleActive}>
              Upload
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box>
        {conditionTable === true ? (
          <>
            <Box style={{ marginTop: '1rem', border: '1px solid blue', borderRadius: '10px' }}>
              <TableContainer
                component={Paper}
                style={{
                  border: '1px solid blue',
                  borderRadius: '10px',
                  overflow: 'hidden', // important for rounding corners of inner content
                }}>
                <Table>
                  <TableHead style={{ backgroundColor: '#f5f5f5' }}>
                    <TableRow style={{ height: '10px' }}>
                      <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>Sl No</TableCell>
                      <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>Condition Desc</TableCell>
                      <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>Condition Type</TableCell>
                      <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>Condition Sub Type</TableCell>
                      <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>Depends on Min Value</TableCell>
                      <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>Depends on Max Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow key={row.id} style={{ height: '10px' }}>
                        <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>{index + 1}</TableCell>
                        <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>{row.description}</TableCell>
                        <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>{row.type}</TableCell>
                        <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>{row.subType}</TableCell>
                        <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>
                          <TextField
                            type="number"
                            variant="standard"
                            size="small"
                            value={row.min}
                            onChange={handleInputChange(index, 'min')}
                            // InputProps={{ style: { fontSize: '9px', height: '15px' } }}
                            InputProps={{
                              inputProps: {
                                style: {
                                  fontSize: '9px',
                                  padding: '4px 6px',
                                },
                              },
                              style: {
                                padding: '0px',
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </TableCell>
                        <TableCell style={{ fontSize: '9px', padding: '2px 4px' }}>
                          <TextField
                            type="number"
                            variant="standard"
                            size="small"
                            value={row.max}
                            onChange={handleInputChange(index, 'max')}
                            // InputProps={{ style: { fontSize: '9px', padding: '4px 8px', height: '15px' } }}
                            InputProps={{
                              inputProps: {
                                style: {
                                  fontSize: '9px',
                                  padding: '4px 6px',
                                },
                              },
                              style: {
                                padding: '0px',
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box display="flex" justifyContent="center" mt={2}>
              <Grid item xs={4}>
                <TextField
                  size="small"
                  margin="dense"
                  fullWidth
                  variant="standard"
                  value={agreementCode}
                  onChange={handleAgreementChange}
                  label="Agreement Code"
                  inputProps={{ maxLength: 7 }}
                />
              </Grid>
            </Box>
            {showTable && (
              <Box style={{ marginTop: '1rem' }}>
                <TableContainer
                  component={Paper}
                  style={{
                    maxHeight: 400,
                    overflowY: 'auto',
                    border: '2px solid blue',
                    borderRadius: '10px',
                    overflow: 'hidden',
                  }}>
                  <Table size="small">
                    {' '}
                    {/* Reduces padding */}
                    <TableHead style={{ backgroundColor: '#f5f5f5' }}>
                      <TableRow>
                        <TableCell style={{ fontSize: '9px' }}>SBIG_RM_ID</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>Intermediary Code</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>Intermediary Name</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>Agreement Name</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>Agreement Code</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>Agent EFF Dt</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>Agent EXP Dt</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>RM Name</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>SBI Channel</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>SBI Channel 1</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>SBI Channel 2</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>IRDA Channel</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>SBI General Branch</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>Branch GSTN Number</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>SBI General Branch Code</TableCell>
                        <TableCell style={{ fontSize: '9px' }}>SBI General Branch Name</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {agreementRows.map((row, index) => (
                        <TableRow key={row.id}>
                          <TableCell style={{ fontSize: '9px' }}>{row.SBIGRMID}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.intermediaryCode}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.intermediaryName}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.agreementName}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.agreementCode}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.agentEffDate}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.agentExoDate}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.rmName}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.sbiChannel}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.sbiChannel1}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.sbiChannel2}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.IRDAChannel}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.sbiGeneralBranch}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.branchGstNumber}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.sbiGeneralBranchCode}</TableCell>
                          <TableCell style={{ fontSize: '9px' }}>{row.sbiGeneralBranchName}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
            <Box
              p={2}
              style={{
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // Custom shadow
                borderRadius: '8px', // Optional rounded corners
                marginTop: '1rem',
                backgroundColor: '#f5f5f5',
                border: '2px solid blue',
                overflow: 'hidden',
              }}>
              <Grid container spacing={4} alignItems="flex-end" style={{ marginTop: '1rem' }}>
                <Grid
                  container
                  spacing={4}
                  alignItems="center"
                  style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      margin="dense"
                      fullWidth
                      variant="standard"
                      label="SP Code"
                      value={basicForm.spCode}
                      onChange={handleBasicChange('spCode')}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth variant="standard" margin="dense" size="small">
                      <InputLabel id="customer-segment-label">Customer Segment</InputLabel>
                      <Select
                        labelId="customer-segment-label"
                        value={basicForm.customerSegment}
                        onChange={handleBasicChange('customerSegment')}
                        label="Customer Segment">
                        {cusetomerSegment?.map(item => {
                          return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      margin="dense"
                      fullWidth
                      variant="standard"
                      label="SSM ID"
                      value={basicForm.ssmId}
                      onChange={handleBasicChange('ssmId')}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={4}
                  alignItems="center"
                  style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      margin="dense"
                      fullWidth
                      variant="standard"
                      label="SSM Name"
                      value={basicForm.ssmName}
                      onChange={handleBasicChange('ssmName')}
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      type="date"
                      size="small"
                      margin="dense"
                      fullWidth
                      variant="standard"
                      label="Policy From"
                      value={basicForm.policyFrom}
                      onChange={handleBasicChange('policyFrom')}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      type="date"
                      size="small"
                      margin="dense"
                      fullWidth
                      variant="standard"
                      label="Policy Upto"
                      value={basicForm.policyUpto}
                      onChange={handleBasicChange('policyUpto')}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={4}
                  alignItems="center"
                  style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                  <Grid item xs={3}>
                    <FormControl fullWidth variant="standard" margin="dense" size="small">
                      <InputLabel id="quote-type-label">Quote Type</InputLabel>
                      <Select
                        labelId="quote-type-label"
                        value={basicForm.quoteType}
                        onChange={handleBasicChange('quoteType')}
                        label="Quote Type">
                        {quoteTypes?.map(item => {
                          return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      margin="dense"
                      fullWidth
                      variant="standard"
                      label="Quote No"
                      value={basicForm.quoteNo}
                      onChange={handleBasicChange('quoteNo')}
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      margin="dense"
                      fullWidth
                      variant="standard"
                      label="Inward No"
                      value={basicForm.inwardNo}
                      onChange={handleBasicChange('inwardNo')}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={4}
                  alignItems="center"
                  style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      margin="dense"
                      fullWidth
                      variant="standard"
                      label="Secure Id"
                      value={basicForm.secureId}
                      onChange={handleBasicChange('secureId')}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth variant="standard" margin="dense" size="small">
                      <InputLabel id="claim-beneficiary-label">Claim Beneficiary</InputLabel>
                      <Select
                        labelId="claim-beneficiary-label"
                        value={basicForm.claimBeneficiary}
                        onChange={handleBasicChange('claimBeneficiary')}
                        label="Claim Beneficiary">
                        {claimBeneficiary?.map(item => {
                          return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth variant="standard" margin="dense" size="small">
                      <InputLabel id="settlement-type-label">Settlement Type</InputLabel>
                      <Select
                        labelId="settlement-type-label"
                        value={basicForm.settlementType}
                        onChange={handleBasicChange('settlementType')}
                        label="Settlement Type">
                        <MenuItem value="cashless">Cashless</MenuItem>
                        <MenuItem value="reimbursement">Reimbursement</MenuItem>
                        <MenuItem value="both">Both</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={4}
                  alignItems="center"
                  style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      margin="dense"
                      fullWidth
                      variant="standard"
                      label="Agent Commission"
                      value={basicForm.agentCommission}
                      onChange={handleBasicChange('agentCommission')}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl variant="standard" margin="dense" size="small">
                      <InputLabel shrink htmlFor="upload-benefit-pdf">
                        Upload Benefit Chart - PDF
                      </InputLabel>
                      <OutlinedInput
                        notched
                        id="upload-benefit-pdf"
                        type="file"
                        label="Choose File"
                        inputProps={{ accept: '.pdf' }}
                        onChange={handleBasicFileChange('benefitChartPdf')}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl variant="standard" margin="dense" size="small">
                      <InputLabel shrink htmlFor="upload-benefit-excel">
                        Upload Benefit Chart - Excel
                      </InputLabel>
                      <OutlinedInput
                        notched
                        id="upload-benefit-excel"
                        type="file"
                        label="Choose File"
                        inputProps={{ accept: '.xlsx,.csv' }}
                        onChange={handleBasicFileChange('benefitChartExcel')}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <Box display="flex" justifyContent="end" mt={2}>
              <Button onClick={handleGenerateQuotation}>Generate Quotation</Button>
            </Box>
          </>
        ) : null}
      </Box>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Quotation Generated</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Your Quotation No:</Typography>
          <Typography variant="h6" color="primary" mt={1}>
            {quotationNo}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default NewGmcComponent;
